import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

export const BasketLineQuantity = (
    props: Immutable<{
        quantity: number;
    }>,
): React.ReactNode => {
    return (
        <div className="basket-line__details__qty">
            <p>
                {t`Qty:`} {props.quantity}
            </p>
        </div>
    );
};
